<template>
  <div>
    <div class="p_header">
      <div class="p_header_box container">
        <div class="p_header_logo fleft">
          <a href="/">
            <img class="logo-main" src="/images/logo.png" alt="Logo" />
            <img class="logo-light" src="/images/logo.png" alt="Logo" />
          </a>
        </div>
        <ul class="p_header_menus">
          <li :class="cur[0]">
            <a href="javascript:void(0)" @click="goto(0, '')">首页</a>
          </li>
          <li
            v-for="(menu, index) in menutree"
            :key="index"
            :class="cur[index + 1]"
          >
            <a href="javascript:void(0)" @click="goto(index + 1, menu)">{{
              menu.title
            }}</a>
          </li>
          <li class="outlink-menu">
            <a href="https://www.host318.com/" target="_blank">
              <img src="/images/s2_41_36.png" />
            </a>
          </li>
        </ul>
        <div
          class="container-menu row align-items-center justify-content-between"
          style="display: none;"
        >
          <!-- Hamburger Menu Start -->
          <div class="col-auto">
            <div class="header-action-area">
              <button class="btn-menu">
                <span></span>
                <span></span>
                <span></span>
              </button>
              <!-- <span class="menu-text">Menu</span> -->
            </div>
          </div>
          <!-- Hamburger Menu Start -->
        </div>
      </div>
    </div>
    <div class="p_banner"><img :src="bannerurl" alt="" /></div>
    <router-view />
    <div class="p_bottom">
      <div class="container">
        <div class="copyright fleft" v-html="copyrightstr"></div>
        <div class="fleft adminbtn fright">
          <a href="/admin" class="admintext">[后台]</a>
        </div>
        <div class="weblink fright">
          <!-- Single button -->
          <div class="btn-group">
            <button
              type="button"
              @click="linknum++"
              class="btn btn-default btn-sm dropdown-toggle"
            >
              站点地图 <span class="caret"></span>
            </button>
            <ul
              class="dropdown-menu"
              :class="linknum % 2 == 0 ? 'hide' : 'show'"
            >
              <li>
                <a href="javascript:void(0)" @click="goto(0, '')">首页</a>
              </li>
              <li v-for="(menu, index) in menutree" :key="index">
                <a
                  href="javascript:void(0)"
                  @click="
                    linknum++;
                    goto(index + 1, menu);
                  "
                  >{{ menu.title }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--== Scroll Top Button ==-->
    <div class="scroll-to-top"><span class="icofont-rounded-up"></span></div>
    <!--== Start Side Menu ==-->
    <aside class="off-canvas-wrapper">
      <div class="off-canvas-inner">
        <div class="off-canvas-overlay"></div>
        <!-- Start Off Canvas Content Wrapper -->
        <div class="off-canvas-content">
          <!-- Off Canvas Header -->
          <div class="off-canvas-header">
            <div class="close-action">
              <button class="btn-close"><i class="icon_close"></i></button>
            </div>
          </div>

          <div class="off-canvas-item">
            <!-- Start Asside Menu Wrapper -->
            <div class="asside-navigation-area">
              <ul class="asside-menu nav" id="assideMenuNav">
                <li>
                  <a
                    :class="cur[0]"
                    href="javascript:void(0)"
                    @click="link(0, '')"
                    >网站首页</a
                  >
                </li>
                <li
                  v-for="(item, index) in menutree"
                  :class="item.childs.length > 0 ? 'dropdown-submenu' : ''"
                  :id="'submenu' + index"
                  :key="index"
                >
                  <a
                    class="collapsed"
                    @click="gotohqse(item)"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#collapse' + index"
                    :aria-controls="'collapse' + index"
                    ><span>{{ item.title }}</span></a
                  >
                  <ul
                    class="dropdown-nav collapse"
                    :id="'collapse' + index"
                    :aria-labelledby="'submenu' + index"
                    data-bs-parent="#assideMenuNav"
                  >
                    <li v-for="(child, i) in item.childs" :key="i">
                      <a
                        href="javascript:void(0)"
                        @click="link(index + 1, child)"
                        >{{ child.title }}</a
                      >
                    </li>
                    <li v-if="item.id == news_mainid">
                      <a :href="outsidelink" target="_blank">郝斯特新闻</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="https://www.host318.com/" target="_blank">
                    四川郝斯特
                  </a>
                </li>
                <!-- <li class="dropdown-submenu" id="submenuOne">
                        <a class="collapsed" href="portfolio.html" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                        aria-controls="collapseOne"><span>Portfolio</span></a>
                        <ul class="dropdown-nav collapse" id="collapseOne" aria-labelledby="submenuOne"
                        data-bs-parent="#assideMenuNav">
                        <li><a href="portfolio.html">Portfolio</a></li>
                        <li><a href="portfolio-details.html">Portfolio Details</a></li>
                        </ul>
                    </li>
                    <li><a href="about.html">About</a></li> -->
              </ul>
            </div>
            <!-- End Asside Menu Wrapper -->
          </div>
          <div class="off-canvas-bottom">
            <div class="qrcode-box">
              <p>{{ qrcodeitem.title }}</p>
              <img :src="imgbaseurl + qrcodeitem.imgUrl" alt="" />
            </div>
          </div>

          <!-- Off Canvas Footer -->
          <div class="off-canvas-footer"></div>
        </div>
        <!-- End Off Canvas Content Wrapper -->
      </div>
    </aside>
    <!--== End Side Menu ==-->
  </div>
</template>

<script>
import configration from "../tools/js/enumconfig";

export default {
  data() {
    return {
      totleCount: 0,
      itemData: {},
      tableData: [],
      showtitle: "新闻列表",
      imgbaseurl: this.$baseURL.fileurl,

      news_mainid: configration.config.enum.pid_news_main, //新闻中心主id
      qesepid: configration.config.enum.homepage6, ///QHSE管理分类id

      menutree: [],
      cur: ["", "", "", "", "", "", ""],
      linknum: 0,

      bannerimg: "",
      page1parameters: {
        parentId: configration.config.enum.homepage1,
      },
      pidaboutus: configration.config.enum.pidguanyuwomen,
      adv_bannerpid: configration.config.enum.adv_bannerpid,
      bannerlist: [],
      bannerurl: "/images/pbanner-1.png",
      pid: "",
      fid: "",
      menucode: "",

      outsidelink: configration.config.enum.news_outside_link,

      copyrightstr: "",
      qrcodeitem: {},
    };
  },

  methods: {
    //更新banner
    getbanner: function(code) {
      let vm = this;

      if (code.length > 0 && vm.bannerlist.length > 0) {
        for (let i = 0; i < vm.bannerlist.length; i++) {
          if (vm.bannerlist[i].description == "adv-" + code) {
            vm.bannerurl = vm.imgbaseurl + vm.bannerlist[i].imgUrl;
          }
        }
      }
    },
    //初始化banner列表
    initbanner: function() {
      let vm = this;
      if (vm.bannerlist.length > 0) {
        return;
      }
      let tpstr = localStorage.getItem(configration.config.enum.cache_banner);
      if (tpstr != undefined && tpstr.length > 0) {
        vm.bannerlist = JSON.parse(tpstr);
      } else {
        vm.$httpi
          .get("/api/v1/articles/adv/GetList?pid=" + vm.adv_bannerpid)
          .then(function(response) {
            if (
              response.data.success &&
              response.data != null &&
              response.data.data.length > 0
            ) {
              vm.bannerlist = response.data.data;
              localStorage.setItem(
                configration.config.enum.cache_banner,
                JSON.stringify(vm.bannerlist)
              );
            }
          });
      }
    },

    getmenus: function() {
      let vm = this;
      let tpstr = localStorage.getItem(configration.config.enum.cache_menu);
      if (tpstr != undefined && tpstr.length > 0) {
        vm.menutree = JSON.parse(tpstr);
      } else {
        vm.$httpi
          .get(
            "/api/v1/dictionary/DictionaryEntry/GetTreeByParentId?parentid=" +
              configration.config.enum.mainid
          )
          .then(function(response) {
            if (response != null && response.data.success) {
              vm.menutree = response.data.data;
              localStorage.setItem(
                configration.config.enum.cache_menu,
                JSON.stringify(vm.menutree)
              );
            }
          });
      }
    },

    getData: function(id) {
      let vm = this;

      vm.$httpi
        .get("/api/v1/articles/doc/getitem?id=" + id)
        .then(function(response) {
          if (response != null && response.data.success) {
            vm.itemData = response.data.data;
            vm.showtitle = vm.itemData.title;
          }
        });
    },

    gotodetail(id) {
      const vm = this;
      vm.$router.push({
        path: "/news/detail",
        query: { id: id, pid: vm.parameters.parentId },
      });
    },

    gotolist(pid) {
      const vm = this;
      vm.$router.push({ path: "/news/list", query: { pid: pid } });
      vm.initpage();
    },

    gotomainweb() {
      window.open("https://www.host318.com/", "_blank");
    },
    freshmenu() {
      let vm = this;

      //获取子菜单
      for (let i = 0; i < vm.menutree.length; i++) {
        if (vm.menutree[i].id == vm.fid) {
          vm.menucode = vm.menutree[i].code;
          break;
        }
      }
    },
    initpage() {
      let vm = this;
      vm.initbanner();
      //绑定
      if (vm.$route.query.fid != undefined && vm.$route.query.fid.length > 0) {
        vm.fid = vm.$route.query.fid;
      }
      if (vm.$route.query.pid != undefined && vm.$route.query.pid.length > 0) {
        vm.pid = vm.$route.query.pid;
      }
      vm.freshmenu();
      vm.getbanner(vm.menucode);
    },
    //跳转gotohqse
    gotohqse(item) {
      let vm = this;
      if (item.childs.length > 0) {
        return void 0;
      } else {
        vm.$router.push({
          path: "/info",
          query: { fid: vm.qesepid, pid: vm.qesepid },
        });
        $(".off-canvas-wrapper").removeClass("active");
      }
    },
    goto(tp, item) {
      let vm = this;
      switch (tp) {
        case 0:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 0, "active");
          vm.$router.push({ path: "/" });
          break;
        case 1:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 1, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/info",
            query: { fid: item.id, pid: item.childs[0].id },
          });
          break;
        case 2:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 2, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/party/list",
            query: { fid: item.id, pid: item.childs[0].id },
          });
          break;
        case 3:
          console.log(tp);
          console.log(item);
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 3, "active");
          vm.getbanner(item.code);
          vm.freshmenu();
          vm.$router.push({
            path: "/info",
            query: { fid: item.id, pid: item.id },
          });
          break;
        case 4:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 4, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/news/list",
            query: { fid: item.id, pid: item.childs[0].id },
          });
          break;
        case 5:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 5, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/job/info",
            query: { fid: item.id, pid: item.childs[0].id },
          });
          break;
      }
    },

    link(tp, item) {
      const vm = this;
      let urlname = "infopage";
      switch (tp) {
        case 0:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 0, "active");
          vm.$router.push({ path: "/" });
          break;
        case 1:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 1, "active");
          vm.getbanner(item.code);

          if (item.id == configration.config.enum.pidhonor) {
            urlname = "publist";
          }
          vm.$router.push({
            name: urlname,
            query: { fid: item.parentId, pid: item.id },
          });
          break;
        case 2:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 2, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/party/list",
            query: { fid: item.parentId, pid: item.id },
          });
          break;
        case 3:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 3, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/info",
            query: { fid: item.id, pid: item.id },
          });
          break;
        case 4:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 4, "active");
          vm.getbanner(item.code);
          vm.$router.push({
            path: "/news/list",
            query: { fid: item.parentId, pid: item.id },
          });
          break;
        case 5:
          vm.cur = ["", "", "", "", "", "", ""];
          vm.$set(vm.cur, 5, "active");
          vm.getbanner(item.code);
          switch (item.code) {
            case "doc-joinus-social":
            case "doc-joinus-shool":
              vm.$router.push({
                path: "/job/find/list",
                query: { pid: item.id, fid: item.parentId },
              });
              break;
            default:
              vm.$router.push({
                path: "/job/info",
                query: { pid: item.id, fid: item.parentId },
              });
              break;
          }
          break;
      }
      $(".off-canvas-wrapper").removeClass("active");
      $(this).removeClass("fix");
    },
    //获取备案信息
    getwebinfo: function() {
      let vm = this;
      vm.copyrightstr = localStorage.getItem(
        configration.config.enum.cache_copyright
      );
      if (vm.copyrightstr == undefined || vm.copyrightstr.length <= 0) {
        vm.$httpi
          .get(
            "api/v1/system/config/getitem?id=" +
              configration.config.enum.sys_copyrightid
          )
          .then(function(response) {
            if (response.data.success) {
              vm.copyrightstr = response.data.data.description;
              localStorage.setItem(
                configration.config.enum.cache_copyright,
                JSON.stringify(vm.copyrightstr)
              );
            }
          });
      } else {
        vm.copyrightstr = JSON.parse(vm.copyrightstr);
      }
    },
    //获取二维码
    getqrcodeinfo: function() {
      let vm = this;
      let tempstr = localStorage.getItem(configration.config.enum.cache_qrcode);
      if (vm.tempstr == undefined || vm.tempstr.length <= 0) {
        vm.$httpi
          .get(
            "api/v1/articles/adv/GetList?num=1&pid=" +
              configration.config.enum.adv_qrcodepid
          )
          .then(function(response) {
            if (response.data.success) {
              vm.qrcodeitem = response.data.data[0];
              localStorage.setItem(
                configration.config.enum.cache_qrcode,
                JSON.stringify(vm.qrcodeitem)
              );
            }
          });
      } else {
        vm.qrcodeitem = JSON.stringify(tempstr);
      }
    },
  },
  mounted() {
    let vm = this;
    //绑定
    vm.getmenus();
    vm.initpage();
    vm.getwebinfo();
    vm.getqrcodeinfo();

    var path = vm.$route.path;
    switch (path) {
      case "/":
        vm.$set(vm.cur, 0, "active");
        this.$forceUpdate();
        break;
      case "/info":
      case "/pub/list":
      case "/pub/detai;":
      case "/partner":
        if (vm.$route.query.pid == vm.qesepid) {
          vm.$set(vm.cur, 3, "active");
          //vm.getbanner('6821363423814303744');
        } else {
          vm.$set(vm.cur, 1, "active");
          //vm.getbanner('6821363423814303744');
        }
        this.$forceUpdate();
        break;
      case "/party/detail":
      case "/party/list":
        vm.$set(vm.cur, 2, "active");
        this.$forceUpdate();
        break;
      case "/news/detail":
      case "/news/list":
        vm.$set(vm.cur, 4, "active");
        this.$forceUpdate();
        break;
      case "/job/info":
      case "/job/find/list":
      case "/job/find/detail":
      case "/job/care/list":
      case "/job/care/detail":
        vm.$set(vm.cur, 5, "active");
        this.$forceUpdate();
        break;
    }

    // Off Canvas JS
    var canvasWrapper = $(".off-canvas-wrapper");
    $(".btn-menu").on("click", function() {
      canvasWrapper.addClass("active");
      $("body").addClass("fix");
    });

    $(".close-action > .btn-close, .off-canvas-overlay").on(
      "click",
      function() {
        canvasWrapper.removeClass("active");
        $(this).removeClass("fix");
      }
    );

    // Scroll Top Hide Show
    $(window).on("scroll", function() {
      if ($(this).scrollTop() > 250) {
        $(".scroll-to-top").fadeIn();
      } else {
        $(".scroll-to-top").fadeOut();
      }

      // Sticky Header
      if ($(".sticky-header").length) {
        var windowpos = $(this).scrollTop();
        if (windowpos >= 80) {
          $(".sticky-header").addClass("sticky");
        } else {
          $(".sticky-header").removeClass("sticky");
        }
      }
    });

    //Scroll To Top
    $(".scroll-to-top").on("click", function() {
      $("html, body").animate({ scrollTop: 0 }, 800);
      return false;
    });
  },
};
</script>

<style scoped>
.linkbtnbg {
  color: #fff;
  background-color: #fd0400;
}

.outlink-menu:hover {
  border-bottom: none !important;
}
.outlink-menu img:hover {
  transform: scale(1.05);
  transition: all 0.3s;
}
</style>
